import cn from 'classnames';
import AnchoredPopover from '../../generic/AnchoredPopover';
import type { ImageWithMetadata } from '../components/SanityImage';
import SanityImage from '../components/SanityImage';
import * as style from './Popover.module.css';

export interface Props {
    id: string;
    name: string;
    summary: string;
    image?: ImageWithMetadata | string;
    url?: string;
    buttonChildren?: React.ReactNode;
}

export default function WineStylePopover({ id, name, summary, image, url, buttonChildren }: Props) {
    return (
        <AnchoredPopover
            className={cn(style.popover, style.stylePopover)}
            id={`popover-wineStyle-${id}`}
            data-modal-name="vinstil"
            buttonChildren={buttonChildren}
        >
            <SanityImage image={image} widths={[263, 263 * 2]} />
            <div>
                <h3>Smak og aroma</h3>
                <h2>{url ? <a href={url}>{name}</a> : name}</h2>
                <p>{summary}</p>
            </div>
        </AnchoredPopover>
    );
}
